// mappings are from https://qa.hungryroot.com/admin/app/dietaryrestriction/
enum DietaryRestrictionsId {
  Vegan = 1,
  Vegetarian = 2,
  Pescatarian = 3,
  DairyFree = 4,
  GlutenFree = 5,
  SoyFree = 6,
  NutFree = 7,
  PeanutFree = 8,
  EggFree = 9,
  ShellfishFree = 10,
  GarlicFree = 13,
  OnionFree = 14,
  SesameFree = 15,
  CaffeineFree = 16,
  GrainFree = 17,
}

// mappings are from https://qa.hungryroot.com/admin/app/tag/
enum TagIds {
  HasMeat = 66,
  HasFish = 67,
  HasGluten = 68,
  HasDairy = 69,
  HasSoy = 70,
  HasNut = 71,
  HasEgg = 72,
  HasPeanut = 73,
  HasByProduct = 74,
  HasShellfish = 75,
  HasGrain = 787,
  HasCaffeine = 786,
  HasGarlic = 789,
  HasOnion = 790,
  HasSesame = 788,
}

export const DietaryRestrictionsIngredientsId = {
  [TagIds.HasDairy]: 'dairy',
  [TagIds.HasGluten]: 'gluten',
  [TagIds.HasSoy]: 'soy',
  [TagIds.HasNut]: 'nuts',
  [TagIds.HasPeanut]: 'peanuts',
  [TagIds.HasEgg]: 'eggs',
  [TagIds.HasShellfish]: 'shellfish',
  [TagIds.HasMeat]: 'meat',
  [TagIds.HasFish]: 'fish',
  [TagIds.HasByProduct]: 'honey',
  [TagIds.HasCaffeine]: 'caffeine',
  [TagIds.HasGrain]: 'grains',
  [TagIds.HasGarlic]: 'garlic',
  [TagIds.HasOnion]: 'onions',
  [TagIds.HasSesame]: 'sesame',
} as const;

export const DietaryRestrictionsIdToTagsId = {
  [DietaryRestrictionsId.DairyFree]: [TagIds.HasDairy],
  [DietaryRestrictionsId.GlutenFree]: [TagIds.HasGluten],
  [DietaryRestrictionsId.SoyFree]: [TagIds.HasSoy],
  [DietaryRestrictionsId.NutFree]: [TagIds.HasNut],
  [DietaryRestrictionsId.PeanutFree]: [TagIds.HasPeanut],
  [DietaryRestrictionsId.EggFree]: [TagIds.HasEgg],
  [DietaryRestrictionsId.ShellfishFree]: [TagIds.HasShellfish],
  [DietaryRestrictionsId.SesameFree]: [TagIds.HasSesame],
  [DietaryRestrictionsId.Vegan]: [
    TagIds.HasMeat,
    TagIds.HasFish,
    TagIds.HasByProduct,
    TagIds.HasDairy,
    TagIds.HasEgg,
    TagIds.HasShellfish,
  ],
  [DietaryRestrictionsId.Vegetarian]: [
    TagIds.HasMeat,
    TagIds.HasFish,
    TagIds.HasShellfish,
  ],
  [DietaryRestrictionsId.Pescatarian]: [TagIds.HasMeat],
  [DietaryRestrictionsId.CaffeineFree]: [TagIds.HasCaffeine],
  [DietaryRestrictionsId.GrainFree]: [TagIds.HasGrain],
  [DietaryRestrictionsId.GarlicFree]: [TagIds.HasGarlic],
  [DietaryRestrictionsId.OnionFree]: [TagIds.HasOnion],
};

export type DietaryRestrictionsIdToText =
  typeof DietaryRestrictionsIngredientsId;

export type DietaryRestrictionsText =
  DietaryRestrictionsIdToText[keyof DietaryRestrictionsIdToText];
